export const fontSizes = {
  h1: {
    fontSize: '48px',
    lineHeight: '64px',
    mobile: {
      fontSize: '26px',
      lineHeight: '36px'
    }
  },
  h2: {
    fontSize: '40px',
    lineHeight: '56px',
    mobile: {
      fontSize: '26px',
      lineHeight: '36px'
    }
  },
  h3: {
    fontSize: '36px',
    lineHeight: '48px',
    mobile: {
      fontSize: '26px',
      lineHeight: '36px'
    }
  },
  h4: {
    fontSize: '32px',
    lineHeight: '44px',
    mobile: {
      fontSize: '22px',
      lineHeight: '32px'
    }
  },
  h5: {
    fontSize: '24px',
    lineHeight: '36px',
    mobile: {
      fontSize: '22px',
      lineHeight: '32px'
    }
  },
  h6: {
    fontSize: '20px',
    lineHeight: '28px',
    mobile: {
      fontSize: '20px',
      lineHeight: '28px;'
    }
  },
  label: {
    large: {
      fontSize: '20px',
      lineHeight: '32px',
      letterSpacing: '.2px',
      mobile: {
        fontSize: '16px',
        lineHeight: '26px',
        letterSpacing: '.16px'
      }
    },
    small: {
      fontSize: '16px',
      lineHeight: '32px',
      letterSpacing: '.16px',
      mobile: {
        fontSize: '14px',
        lineHeight: '24px',
        letterSpacing: '.14px'
      }
    }
  },
  subtitle: {
    large: {
      fontSize: '20px',
      lineHeight: '32px',
      mobile: {
        fontSize: '16px',
        lineHeight: '26px'
      }
    },
    medium: {
      fontSize: '20px',
      lineHeight: '32px',
      mobile: {
        fontSize: '16px',
        lineHeight: '26px'
      }
    },
    small: {
      fontSize: '16px',
      lineHeight: '26px',
      mobile: {
        fontSize: '14px',
        lineHeight: '24px'
      }
    }
  },
  paragraph: {
    xLarge: {
      fontSize: '24px',
      lineHeight: '36px',
      mobile: {
        fontSize: '18px',
        lineHeight: '30px'
      }
    },
    large: {
      fontSize: '20px',
      lineHeight: '32px',
      mobile: {
        fontSize: '16px',
        lineHeight: '26px'
      }
    },
    medium: {
      fontSize: '16px',
      lineHeight: '26px',
      mobile: {
        fontSize: '16px',
        lineHeight: '26px'
      }
    },
    small: {
      fontSize: '14px',
      lineHeight: '24px',
      mobile: {
        fontSize: '14px',
        lineHeight: '24px'
      }
    },
    insight: {
      fontSize: '18px',
      lineHeight: '36px',
      mobile: {
        fontSize: '18px',
        lineHeight: '34px'
      }
    }
  },
  // To Do: Refactor for different quote sizes
  quote: {
    fontSize: '24px',
    lineHeight: '40px',
    mobile: {
      fontSize: '24px',
      lineHeight: '40px'
    }
  }
};
